import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: process.env.REACT_APP_GLITCHTIP_DSN,
  environment: process.env.NODE_ENV,
  // Capture 100% of transactions in development, reduce in production
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
  // Only initialize when a DSN is provided
  enabled: Boolean(process.env.REACT_APP_GLITCHTIP_DSN),
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Our team has been notified.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();